import { render } from "./userEdit.vue?vue&type=template&id=2bef9954&scoped=true"
import script from "./userEdit.vue?vue&type=script&lang=js"
export * from "./userEdit.vue?vue&type=script&lang=js"

import "./userEdit.vue?vue&type=style&index=0&id=2bef9954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bef9954"]])

export default __exports__